import { Box, Button, Link, Typography } from "@mui/material";
import "./styles.css";
import Latex from "react-latex-next";
import NextAction from "../../utils/NextAction";

export default function Controls({ controls }) {
  const {
    xRotation,
    yRotation,
    zRotation,
    xPosition,
    yPosition,
    zPosition,
    xScale,
    yScale,
    zScale,
    setXRotation,
    setYRotation,
    setZRotation,
    setXPosition,
    setYPosition,
    setZPosition,
    setXScale,
    setYScale,
    setZScale,
  } = controls;
  return (
    <div className="controls">
      <div className="controlGroup">
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Welcome to Robotics101 : Translation
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          Nice to see you on Robotics101! Robotics101 is a website that{" "}
          <b>collects interactive and visualization tools</b> for various
          knowledge points in robotics.
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          Every page here has a text explanation and an interactive panel on the
          left side, and a visualization interface on the right side. You can
          try this translation example first and explore more knowledge points
          on this website.
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          This is the visualization of translation matrix. The dark axes
          "O'-xyz'" are the shifted frame axes and the light one is the
          reference frame "O-xyz".
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Here are the position of "O'-xyz". Feel free to change the value.
        </Typography>
        <div className="control">
          <label>X Position</label>
          <input
            value={xPosition}
            onChange={(e) => setXPosition(e.target.value)}
            step={1 / 32}
            type="number"
          />
        </div>
        <div className="control">
          <label>Y Position</label>
          <input
            value={yPosition}
            onChange={(e) => setYPosition(e.target.value)}
            step={1 / 32}
            type="number"
          />
        </div>
        <div className="control">
          <label>Z Position</label>
          <input
            value={zPosition}
            onChange={(e) => setZPosition(e.target.value)}
            step={1 / 32}
            type="number"
          />
        </div>
        <Latex>
          {` $$\\textbf{ o' } = \\left[ \\begin{array}
          {c} x \\\\ y \\\\ z \\\\ \\end{array}
          \\right] $$`}
        </Latex>
      </div>
      <Typography>
        <br />
        I've created a{" "}
        <a href="https://discord.gg/TfwZ3hH2D2">Discord channel</a> dedicated to
        robotic learning and circuit design. You're invited to join and share
        your robotic learning/teaching experiences with fellow enthusiasts from
        around the world. Also, I wish you could tell me what I can do on this
        website to make robotic learning easier.
      </Typography>
      <NextAction label={"Next: Rotation"} to="/rotation" />
    </div>
  );
}
